import { Box, styled } from '@mui/material';

export const Skeleton = styled(Box)(() => {
  const theme = localStorage.getItem('theme');
  return ({
    backgroundImage: `linear-gradient(
      -90deg,
      #e7edf1 0%,
      #f8f8f8 50%,
      #e7edf1 100%
    );`,
    backgroundSize: '400% 400%',
    animation: 'shimmer 1.2s ease-in-out infinite',
    '@keyframes shimmer': {
      '0%': {
        backgroundPosition: '0% 0%'
      },
      '100%': {
        backgroundPosition: '-135% 0%'
      }
    },
    '&.white': {
      backgroundImage: 'linear-gradient(-90deg, #fff 0%, #e7edf1 50%, #fff 100%)'
    },
  
    ...( theme === 'dark' && {
        backgroundImage: `linear-gradient(90deg, #333 0%, #666 50%, #333 100%);`,
    }),
  })
});
